export default "__VITE_ASSET__23b31fdc__"